import * as firebase from 'firebase'
import ReactGA from 'react-ga';
// import Cookies from 'universal-cookie';

// export const Login=()=>{
//   const provider = new firebase.auth.GoogleAuthProvider();
//   // provider.addScope('https://www.googleapis.com/auth/contacts.readonly');
//   // provider.addScope('https://www.googleapis.com/auth/calendar');
//   ReactGoogleAnalytics('Auth','Login',null,null,null);
//   firebase.auth().signInWithRedirect(provider);
// }

export const SignIn=(email, password)=>{
  return firebase.auth().signInWithEmailAndPassword(email, password)
    .then((user)=>{
      console.log('user is ', user);
      ReactGoogleAnalytics('Auth','Login',null,null,null);
    })
    .catch(error=>{
      console.log(error);
      return error;
    })
    // .catch((error)=>{
    // if (error.code === 'auth/wrong-password') {
    //   this.setState({signing:false, passwordError:true,snackStatus:true,snackMessage:'Wrong password.'})
    // } else {
    //   this.setState({signing:false, emailError:true, passwordError:true,snackStatus:true,snackMessage:error.message})
    // }
    // console.log(error);
  // });
}

export const Logout=()=>{
  ReactGoogleAnalytics('Auth','Logout',null,null,null);
  firebase.auth().signOut();
}

export const ReactGoogleAnalytics=(category,action,label,value,nonInteraction)=>{
  let event = {
    category,
    action,
    label,
  };
  if(value!==null){
    event.value = value;
  };
  if(nonInteraction!==null){
    event.nonInteraction = nonInteraction;
  }
  // console.log('about to GA ', event);
  ReactGA.event(event);
}

export const Favorite=(uid,jid,oid,status)=>{
  const ref = firebase.database().ref();
  if(status){
    ref.child(`favorites/${uid}/${oid}`).update({
      oid,
      jid,
      status,
      timestamp:Date.now(),
    })
  }
  else{
    ref.child(`favorites/${uid}/${oid}`).remove();
  }
}

export const GetNotificationsPermission=(uid)=>{
  const messaging = firebase.messaging();
  return messaging.requestPermission()
  .then(()=>{
    console.log('Notification permission granted.');
    // TODO(developer): Retrieve an Instance ID token for use with FCM.
    // ...
    GetFCMToken(uid);
  })
  .catch((err)=>{
    console.log('Unable to get permission to notify.', err);
  });
}

export const GetFCMToken=(uid)=>{
  const messaging = firebase.messaging();
  messaging.getToken()
  .then((currentToken)=>{
    if (currentToken) {
      console.log(currentToken);
      firebase.database().ref(`settings/${uid}/`).update({
        notifications:true,
        token:currentToken,
      })
      // sendTokenToServer(currentToken);
      // updateUIForPushEnabled(currentToken);
    } else {
      // Show permission request.
      console.log('No Instance ID token available. Request permission to generate one.');
      // Show permission UI.
      // updateUIForPushPermissionRequired();
      // setTokenSentToServer(false);
    }
  })
  .catch((err)=>{
    console.log('An error occurred while retrieving token. ', err);
    // showToken('Error retrieving Instance ID token. ', err);
    // setTokenSentToServer(false);
  });
}

// export const checkOfferPermission=(jid,oid,uid)=>{
//   const url = `https://us-central1-talent-7d36f.cloudfunctions.net/getPermissionIfPrivateJob?oid=${oid}&jid=${jid}&uid=${uid}`;
//   console.log(url);
//   fetch(url)
//   .then(res=>{
//     if(res.status===200){
//       console.log('success');
//       return true;
//     }
//     else{
//       console.log('success');
//       return false;
//     }
//   })
//   .catch(err=>{
//     console.log(err);
//     return false;
//   })
// }

// export function GetLogoFromGlassdoor(url){
//   return new Promise((resolve, reject)=>{
//     const ua = window.navigator.userAgent;
//     const proxyUrl = 'https://cors-anywhere.herokuapp.com/';
//     let options = {
//       headers : {
//         'Content-Type': 'application/json',
//         'Accept': 'application/json'
//        }
//     }
//     fetch(proxyUrl + url)
//     // if (res.status !==200) {console.log(`Looks like there was a problem. Please try logging in again. Code: ${res.status}`);return;};
//     .then(blob=>blob.blob())
//     .then(blob => {
//       console.log(blob);
//       return blob
//       // return blob.json()
//     })
//     .then(data => {
//       console.log(data);
//       var objectURL = URL.createObjectURL(data);
//       console.log(objectURL);
//     })
//     .catch(e => {
//       console.log(e);
//       reject(Error(e));
//     });
//   })
// }

export function SearchGlassdoor(value){
  return new Promise((resolve, reject)=>{
    const ua = window.navigator.userAgent;
    // const {value} = this.state;
    // const url  = `http://api.glassdoor.com/api/api.htm?v=1&format=json&t.p=198744&t.k=dMGu3jzZ1B1&action=employers&q=${value}&useragent=${ua}`;
    const proxyUrl = 'https://cors-anywhere.herokuapp.com/',
    targetUrl = `http://api.glassdoor.com/api/api.htm?v=1&format=json&t.p=198744&t.k=dMGu3jzZ1B1&action=employers&q=${value}&useragent=${ua}`
    fetch(proxyUrl + targetUrl)
    // if (res.status !==200) {console.log(`Looks like there was a problem. Please try logging in again. Code: ${res.status}`);return;};
    .then(blob => blob.json())
    .then(data => {
      // this.setState({results:data.response.employers})
      // console.log(data.response.employers);
      // document.querySelector("pre").innerHTML = JSON.stringify(data, null, 2);
      // this.setState({searching:false})
      resolve(data);
    })
    .catch(e => {
      console.log(e);
      // this.setState({searching:false})
      reject(Error(e));
    });
  })
}

export function GetToken(){
  return new Promise((resolve, reject)=>{
    // const cookies = new Cookies();
    // let token = cookies.get('__session')
    // if(!!token){
    //   console.log('!!token');
    //   resolve(token)
    // }
    // else{
      firebase.auth().currentUser.getIdToken()
      .then(newToken=>{
        // console.log('newToken',token);
        // const cookies = new Cookies();
        // cookies.set('__session', token, { path: '/', maxAge: 60 });
        // token=newToken;
        // resolve(token)
        resolve(newToken)
      })
      .catch((err)=>{
        reject(Error(err));
      })
    // }
  });
}

// export const SetSessionCookie = ()=>{
  // const cookies = new Cookies();
  // cookies.remove('__session')
  // const token = cookies.get('__session');
  // console.log('token: ', token);
  // if(!!token){return}else{
    // console.log('no token');
  // firebase.auth().currentUser.getIdToken().then(token=>{
    // const cookies = new Cookies();
    // cookies.set('__session', token, { path: '/', maxAge: 60 });
    // console.log(cookies.get('__session'));
  // })
  // }
// }

// export const getImage = (src) => {
//   return new Promise((resolve, reject) => {
//     let downloadingImage = new Image();
//     downloadingImage.src = src;
//     downloadingImage.onload = ()=>{
//       resolve(src)
//     };
//   })
// }



// WEBPACK FOOTER //
// ./src/helper/functions.js